import { Plus, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function Events() {
  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold mb-2">Events</h1>
          <p className="text-muted-foreground">Schedule and manage upcoming events.</p>
        </div>
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          New Event
        </Button>
      </div>

      <div className="glass-card p-8 rounded-xl flex flex-col items-center justify-center min-h-[300px]">
        <Calendar className="h-12 w-12 text-muted-foreground mb-4" />
        <h3 className="font-semibold mb-2">No events scheduled</h3>
        <p className="text-muted-foreground text-sm text-center max-w-sm">
          Create your first event to get started with party planning and management.
        </p>
      </div>
    </div>
  );
}
